'use client';

import { useClerk } from '@/context/clerk-context';
import { useCurrentUser } from '@/context/current-user-context';
import { useRef } from 'react';
import { Button } from '../ui/button';

export default function MobileMenu() {
  const mobileDropdownEl = useRef<HTMLDivElement>(null);

  const { user, setUser } = useCurrentUser();
  const { clerk } = useClerk();

  const handleSignOut = () => {
    clerk?.signOut();
    setUser(null);
  };

  const handleSignIn = () => {
    clerk?.redirectToSignIn();
  };

  return (
    <div ref={mobileDropdownEl} className="mt-1 h-full bg-white md:hidden">
      <div className="space-y-1 px-2 pt-2 pb-3 sm:px-3">
        {user && (
          <Button onClick={handleSignOut} className="w-full">
            Sign Out
          </Button>
        )}
        {!user && (
          <Button disabled onClick={handleSignIn} className="w-full">
            Sign in
          </Button>
        )}
      </div>
    </div>
  );
}
